import { c as _c } from "react/compiler-runtime";
import Heading from '@/components/typography/Heading';
import { cn } from '@/lib/styles';
import type { GridCardProps } from '@/types/general';
import { TileIcon } from './shared/TileIcon';
export function FileFormatCard(t0) {
  const $ = _c(7);
  const {
    icon,
    title
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = icon && <TileIcon icon={icon} size="large" className="items-center" />;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = title && <div className="flex flex-col items-center text-center"><Heading tag="h3" fontSize="headingMedium" className={cn("font-bold text-center group-data-[state=active]:text-brand-salmon group-hover:text-brand-salmon transition-colors ")}>{title}</Heading></div>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col lg:pt-10 lg:pb-5 lg:gap-10 pb-4 pt-8 gap-8 justify-center">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}